import {
  AfterViewInit,
  Component,
  forwardRef,
  inject,
  Injector,
  input,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import { FormField } from '@shared/classes';
import { Dict, InputSelectFieldOptions } from '@shared/models';

import { FieldErrorsComponent } from '../field-errors/field-errors.component';

@Component({
  selector: 'b2c-select',
  styleUrl: './select.component.scss',
  templateUrl: './select.component.html',
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
    },
  ],
  imports: [FormsModule, FieldErrorsComponent],
})
export class SelectComponent extends FormField implements AfterViewInit {
  label = input<string>('');
  labelStyles = input<Dict>({});
  type = input<string>('select');
  placeholder = input<string>('');
  id = input<number>(Math.random());
  compactCss = input<boolean>(false);
  serverErrorMessage = input<string>('');
  options = input<InputSelectFieldOptions[]>([]);
  errorMessages = input<Record<string, string>>({});

  private readonly injector: Injector = inject(Injector);

  ngAfterViewInit(): void {
    const ngControl: NgControl | null = this.injector.get(NgControl, null);
    if (ngControl) {
      this.control = ngControl.control as FormControl;
    }
  }
}
